/**
 * Validates a value is an integer number.
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null
 * @name integer
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  return Promise.resolve(/^-?\d+$/.test(value) ? null : 'not-integer');
}

module.exports = validate;